import { render, staticRenderFns } from "./BatchListTable.vue?vue&type=template&id=faa88d48"
import script from "./BatchListTable.vue?vue&type=script&lang=js"
export * from "./BatchListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports